import InformationLineIcon from 'remixicon-react/InformationLineIcon';
export type ComparisonTableProps = {
  data: {
    columns: string[];
    heading: string;
    categoryWise: {
      name: string;
      rows: {
        name: string;
        tooltipInfo?: string;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        values: any[];
      }[];
    }[];
  };
};

const TableSection = (props: {
  category: ComparisonTableProps['data']['categoryWise'][0];
  columns: ComparisonTableProps['data']['columns'];
}) => {
  return (
    <div className="relative w-[200%] lg:w-full">
      <div className="heading-6 my-5  grid grid-cols-3 pl-5">
        <div>{props.category.name} </div>
        {props.columns.map((c, idx) => {
          return (
            <div className="pl-5" key={idx}>
              {c}
            </div>
          );
        })}
      </div>
      <div className="bg-surface-grey mt-2 rounded-md  p-3">
        {props.category.rows.map((row, idx) => {
          return (
            <div
              className={`grid grid-cols-3 gap-x-10 p-4 ${idx % 2 === 1 ? 'bg-surface-grey' : 'bg-white'}`}
              key={idx}
            >
              <div className="flex items-center">
                {row.name}
                {row.tooltipInfo && (
                  <InformationLineIcon
                    data-tip={row.tooltipInfo}
                    className="text-grey-400 ml-1 cursor-pointer"
                    size={16}
                  />
                )}
              </div>
              {row.values.map((value, idx) => {
                return <div key={idx}>{value}</div>;
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};
export const ComparisonTable = ({ comparisonTableData }: { comparisonTableData: ComparisonTableProps['data'] }) => {
  return (
    <div className="container py-20">
      <h2 className="heading-3 mb-16 lg:text-center">{comparisonTableData.heading}</h2>
      <div className="relative  overflow-x-auto lg:overflow-hidden">
        {comparisonTableData.categoryWise.map((category, index) => {
          return <TableSection key={index} category={category} columns={comparisonTableData.columns} />;
        })}
      </div>
    </div>
  );
};

export default ComparisonTable;
